(() => {
  const initialized = new WeakSet();
  function initialize(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    if (root.dataset.ptscMode !== 'live') return;
    const received = new Set();
    let started = false;
    let pageViewed = false;
    function publish(name, imageCount) {
      const privacy = window.Shopify?.customerPrivacy;
      if (typeof privacy?.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return false;
      if (typeof window.Shopify?.analytics?.publish !== 'function') return false;
      const data = { form_id: 'sell_cards', device: window.matchMedia('(max-width:700px)').matches ? 'mobile' : 'desktop' };
      if (Number.isInteger(imageCount)) data.image_count = Math.min(20, Math.max(0, imageCount));
      window.Shopify.analytics.publish(`poketalk_sell_cards:${name}`, data);
      return true;
    }
    function view() {
      if (!pageViewed) pageViewed = publish('page_view');
    }
    view();
    if (typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed !== 'function' && typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => { if (!error) view(); });
    }
    document.addEventListener('visitorConsentCollected', view);
    root.addEventListener('input', (event) => {
      if (!event.target.closest('[data-ptsc-app-form]') || started) return;
      started = publish('form_start');
    }, { passive: true });
    root.addEventListener('poketalk:request-received', (event) => {
      const detail = event.detail;
      if (detail?.received !== true || typeof detail.confirmationId !== 'string' || !detail.confirmationId.trim()) return;
      if (received.has(detail.confirmationId)) return;
      if (publish('request_received', detail.imageCount)) received.add(detail.confirmationId);
    });
  }
  function initializeAll() {
    document.querySelectorAll('[data-ptsc-root]').forEach(initialize);
  }
  initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
